const PrivacyInfo = () => {
  return (
    <div className="max-width">
      <h3>Privacy Policy</h3>
      <p>
        Disclaimer: The information contained in this communication is
        confidential, and is intended solely for the addressee. This
        communication may contain information proprietary to Rozwon Consultants
        LLC (“Rozwon Consultants, Rozwon Health or Rozwon”), and may not be
        reproduced or disseminated in whole or in part without Rozwon
        Consultants LLC written consent. Rozwon Consultants LLC. does not
        warrant that any information contained herein is complete or correct.
        This communication is not an offer or agreement to enter into any
        transaction, and is not a confirmation of any transaction described
        herein unless the context clearly indicates the contrary. This
        communication may contain views or opinions that are not necessarily
        those of Rozwon Consultants, Rozwon Health, or Rozwon. You shall not be
        entitled to place any reliance on the information contained in this
        communication for the purposes of entering into any proposed transaction
        or otherwise.
      </p>
    </div>
  );
};

export default PrivacyInfo;
